import * as React from 'react';
import PropTypes from 'prop-types';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';


function ValueLabelComponent(props) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
};

const AirbnbSlider = styled(Slider)(({ theme }) => ({
  color: '#0B5FFF',
  height: 3,
  padding: '13px 0px',
  '& .MuiSlider-thumb': {
    height: 27,
    width: 27,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
    },
    '& .airbnb-bar': {
      height: 9,
      width: 1,
      backgroundColor: 'currentColor',
      marginLeft: 1,
      marginRight: 1,
    },
  },
  '& .MuiSlider-track': {
    height: 3,
  },
  '& .MuiSlider-rail': {
    color: theme.palette.mode === 'dark' ? '#bfbfbf' : '#d8d8d8',
    opacity: theme.palette.mode === 'dark' ? undefined : 1,
    height: 3,
  },
}));

function AirbnbThumbComponent(props) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
    </SliderThumb>
  );
}

AirbnbThumbComponent.propTypes = {
  children: PropTypes.node,
};

export default function CustomizedSlider({ value = [], onChange }) {

  const [sliderVal, setSliderVal] = React.useState([]);
  const [minVal, setMinVal] = React.useState("");
  const [maxVal, setMaxVal] = React.useState("");

  React.useEffect(()=>{
    setMaxVal(value[1]);
    setMinVal(value[0]);
  },[])

  React.useEffect(()=>{
    setSliderVal(value);
    setMaxVal(value[1]);
    setMinVal(value[0]);
  },[value])

  const handleChange = (event, newValue) => {
    setMaxVal(newValue[1]);
    setMinVal(newValue[0]);
    onChange(newValue)
  };

  const handleMinInputChange = (event) => {
    setMinVal(event.target.value)
    var temp = [...sliderVal]
    temp[0] = event.target.value;
    setSliderVal(temp)
    onChange(temp)
  };
  const handleMaxInputChange = (event) => {
    setMaxVal(event.target.value)
    var temp = [...sliderVal];
    temp[1] = event.target.value;
    setSliderVal(temp)
    onChange(temp)
  };
  return (
    <div>
      <div className='mx-5'>
        <Box sx={{ minWidth: 220 }}>
          <AirbnbSlider
            components={{ Thumb: AirbnbThumbComponent }}
            getAriaLabel={(index) => (index === 0 ? 'Minimum price' : 'Maximum price')}
            defaultValue={[0, 40]}
            onChange={handleChange}
            value={sliderVal}
            min={0}
            max={20}
          />
        </Box>
      </div>
      <div className='flex grid grid-cols-12 mt-2'>
        <div className="col-span-4">
          <div className="flex justify-center">
            <TextField
              value={minVal}
              size="small"
              onChange={handleMinInputChange}
              inputProps={{
                step: 1,
                min: 0,
                max: 20,
                type: 'number',
                'aria-labelledby': 'input-slider',
              }}
            />
          </div>
          <label className="flex justify-center">Min</label>
        </div>
        <div className="flex col-span-3 pt-2 justify-center -ml-6">-</div>
        <div className="col-span-4">
          <div className="flex justify-center">
            <TextField
              value={maxVal}
              size="small"
              variant="outlined"
              onChange={handleMaxInputChange}
              inputProps={{
                step: 1,
                min: 0,
                max: 20,
                type: 'number',
                'aria-labelledby': 'input-slider',
              }}
            />
          </div>
          <label className="flex justify-center">Max</label>
        </div>
      </div>
    </div>
  );
}